import { Modal } from 'bootstrap';

const toggleIcon = document.querySelector('.navbar__brand__menu-toggle');
const mobileNav = document.querySelector('nav');
const searchIcon = document.querySelector('.mobile-search-icon');
const closeSearchIcon = document.querySelector('.mobile-close-search');
const searchForm = document.querySelector('.search-form');

let isMobileView = null;
let mobileLoginList = null;

const renderNavbar = () => {
  const windowWidth = window.innerWidth;
  const nowMobile = windowWidth < 768;

  // If state unchanged, skip
  if (isMobileView === nowMobile) return;
  isMobileView = nowMobile;

  const desktopLinkBar = document.querySelector('.navbar__login');
  const languagePicker = document.querySelector('.language-picker');
  const languagePickerButton = document.getElementById('language-picker-button');
  const yourlocationPicker = document.querySelector('.your-location-picker');
  const yourlocationPickerButton = document.getElementById('your-location-picker-button');
  const yourlocationInput = document.getElementById('yourlocation');

  // Show your location modal on every render (optional)
  const modalEl = document.getElementById('defaultYourLocationPickerModal');
  if (modalEl) {
    const modal = new Modal(modalEl);
    modal.show();
  }

  if (nowMobile) {
    // Remove existing mobile menu if exists (to avoid duplicates)
    if (mobileLoginList && mobileLoginList.parentNode) {
      mobileLoginList.parentNode.removeChild(mobileLoginList);
    }

    // Create mobile login list container fresh
    mobileLoginList = document.createElement('ul');
    mobileLoginList.classList.add('nav', 'navbar-nav', 'navbar__menu__login');

    const desktopLinks = desktopLinkBar.querySelectorAll('a:not(.dropdown-link)');

    if (desktopLinks.length > 0) {
      // Hide search form on mobile
      searchForm.classList.add('search-form--hidden');

      // Append mobile menu container to nav
      mobileNav.appendChild(mobileLoginList);

      // Move language picker and your location picker into mobile menu
      [languagePicker, yourlocationPicker].forEach(picker => {
        if (!picker) return;
        const wrapper = document.createElement('li');
        wrapper.classList.add('nav-item', 'login-item');
        picker.classList.add('nav-link');
        wrapper.appendChild(picker);
        mobileLoginList.appendChild(wrapper);
      });

      // Move desktop links into mobile menu
      desktopLinks.forEach(link => {
        const wrapper = document.createElement('li');
        wrapper.classList.add('nav-item', 'login-item');
        link.classList.add('nav-link');
        wrapper.appendChild(link);
        mobileLoginList.appendChild(wrapper);
      });

      // Remove all li in desktop link bar to avoid duplicates
      desktopLinkBar.querySelectorAll('li').forEach(li => li.remove());

      // Hide input in mobile mode
      if (yourlocationInput) yourlocationInput.type = 'hidden';

      // Set bootstrap 5 modal toggle attributes
      if (languagePickerButton) {
        languagePickerButton.setAttribute('data-bs-toggle', 'modal');
        languagePickerButton.setAttribute('data-bs-target', '#languagePickerModal');
        languagePickerButton.setAttribute('aria-expanded', 'false');
        languagePickerButton.setAttribute('aria-controls', 'languagePickerModal');
      }

      if (yourlocationPickerButton) {
        yourlocationPickerButton.setAttribute('data-bs-toggle', 'modal');
        yourlocationPickerButton.setAttribute('data-bs-target', '#yourlocationPickerModal');
        yourlocationPickerButton.setAttribute('aria-expanded', 'false');
        yourlocationPickerButton.setAttribute('aria-controls', 'yourlocationPickerModal');
      }
    }
  } else {
    // Desktop view

    // If mobile menu exists, move its children back to desktop menu
    if (mobileLoginList) {
      const desktopUl = desktopLinkBar.querySelector('ul') || document.createElement('ul');

      // Append ul if it didn't exist before
      if (!desktopLinkBar.contains(desktopUl)) desktopLinkBar.appendChild(desktopUl);

      // Move pickers and links back to desktop menu
      if (languagePicker) {
        const wrapper = document.createElement('li');
        wrapper.appendChild(languagePicker);
        wrapper.classList.remove('nav-link');
        desktopUl.appendChild(wrapper);
      }

      if (yourlocationPicker) {
        const wrapper = document.createElement('li');
        wrapper.appendChild(yourlocationPicker);
        wrapper.classList.remove('nav-link');
        desktopUl.appendChild(wrapper);
      }

      // Move any other links in mobileLoginList
      mobileLoginList.querySelectorAll('li').forEach(li => {
        const link = li.querySelector('a');
        if (link) {
          const wrapper = document.createElement('li');
          wrapper.appendChild(link);
          wrapper.classList.remove('nav-link');
          desktopUl.appendChild(wrapper);
        }
      });

      // Remove mobile menu from DOM
      if (mobileLoginList.parentNode) {
        mobileLoginList.parentNode.removeChild(mobileLoginList);
      }
      mobileLoginList = null;
    }

    // Show search form on desktop
    searchForm.classList.remove('search-form--hidden');

    // Set yourlocation input back to text
    if (yourlocationInput) yourlocationInput.type = 'text';

    // Set bootstrap 5 dropdown toggle attributes for desktop
    if (languagePickerButton) {
      languagePickerButton.setAttribute('data-bs-toggle', 'dropdown');
      languagePickerButton.removeAttribute('data-bs-target');
      languagePickerButton.setAttribute('aria-expanded', 'false');
      languagePickerButton.removeAttribute('aria-controls');
    }

    if (yourlocationPickerButton) {
      yourlocationPickerButton.setAttribute('data-bs-toggle', 'dropdown');
      yourlocationPickerButton.removeAttribute('data-bs-target');
      yourlocationPickerButton.setAttribute('aria-expanded', 'false');
      yourlocationPickerButton.removeAttribute('aria-controls');
    }
  }
};

// ---- Event Listeners ----

renderNavbar();

toggleIcon?.addEventListener('click', (e) => {
  mobileNav?.classList.toggle('open');
  e.stopPropagation();
});

document.addEventListener('click', () => {
  mobileNav?.classList.remove('open');
});

// Debounce resize so it doesn't flood events
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(renderNavbar, 150);
});

searchIcon?.addEventListener('click', () => {
  searchForm?.classList.remove('search-form--hidden');
});

closeSearchIcon?.addEventListener('click', () => {
  searchForm?.classList.add('search-form--hidden');
});
